// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer__footer___EfZdO {
    background: #121217;
    color: #7f7f90;
    width: 100vw;
    height: 15vh;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.5;
    padding-bottom: 10vh;
    padding-top: 5vh;
    z-index: 2;
    /*padding-left: 30vw;*/
}

.Footer__footerContainer___Cc66z {
    width: 80vw;
    display: flex;
    justify-content: space-around;
    z-index: 2;
    /*background: red;*/
    /*align-items: center;*/
}

.Footer__footerItems___UgBU3 {
    flex-direction: row;
    display: flex;
    width: 50%;
    justify-content: space-around;
    /*justify-content: space-around;*/
    /*margin-left: 10vw;*/
}

.Footer__footerTitle___RNG2j {
    font-weight: bold;
    margin-bottom: 2vh;
     color: #7f7f90;
}

.Footer__link___KEGQH {
    text-decoration: none;
    color: #7f7f90;
    display: block;
}

.Footer__link___KEGQH:hover {
    text-decoration: underline;
}

@media screen and (max-width: 1100px) {
    .Footer__mobileFooter___ZccnH {
        /*width: 90vw;*/
        background: #121217;
        color: #7f7f90;
        line-height: 1.5;
        padding-left: 5vw;
        padding-right: 5vw;
        padding-top: 2vh;
        padding-bottom: 10vh;

    }
    .Footer__footerGroup___nluoB {
        margin-top: 4vh;
    }
}

.Footer__footerText___mEy8v {
     color: #7f7f90;
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,UAAU;IACV,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;KACjB,cAAc;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;;IAExB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;KACK,cAAc;AACnB","sourcesContent":[".footer {\n    background: #121217;\n    color: #7f7f90;\n    width: 100vw;\n    height: 15vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    line-height: 1.5;\n    padding-bottom: 10vh;\n    padding-top: 5vh;\n    z-index: 2;\n    /*padding-left: 30vw;*/\n}\n\n.footerContainer {\n    width: 80vw;\n    display: flex;\n    justify-content: space-around;\n    z-index: 2;\n    /*background: red;*/\n    /*align-items: center;*/\n}\n\n.footerItems {\n    flex-direction: row;\n    display: flex;\n    width: 50%;\n    justify-content: space-around;\n    /*justify-content: space-around;*/\n    /*margin-left: 10vw;*/\n}\n\n.footerTitle {\n    font-weight: bold;\n    margin-bottom: 2vh;\n     color: #7f7f90;\n}\n\n.link {\n    text-decoration: none;\n    color: #7f7f90;\n    display: block;\n}\n\n.link:hover {\n    text-decoration: underline;\n}\n\n@media screen and (max-width: 1100px) {\n    .mobileFooter {\n        /*width: 90vw;*/\n        background: #121217;\n        color: #7f7f90;\n        line-height: 1.5;\n        padding-left: 5vw;\n        padding-right: 5vw;\n        padding-top: 2vh;\n        padding-bottom: 10vh;\n\n    }\n    .footerGroup {\n        margin-top: 4vh;\n    }\n}\n\n.footerText {\n     color: #7f7f90;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer__footer___EfZdO`,
	"footerContainer": `Footer__footerContainer___Cc66z`,
	"footerItems": `Footer__footerItems___UgBU3`,
	"footerTitle": `Footer__footerTitle___RNG2j`,
	"link": `Footer__link___KEGQH`,
	"mobileFooter": `Footer__mobileFooter___ZccnH`,
	"footerGroup": `Footer__footerGroup___nluoB`,
	"footerText": `Footer__footerText___mEy8v`
};
export default ___CSS_LOADER_EXPORT___;
